import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ToastController } from 'ionic-angular';
import { DataProvider } from '../../providers/data/data';


@IonicPage()
@Component({
  selector: 'page-join-game',
  templateUrl: 'join-game.html',
})
export class JoinGamePage {
  name: String;
  gameCode: String;
  constructor(public navCtrl: NavController, public navParams: NavParams, public toastCtrl: ToastController, public dataProvider: DataProvider) {
    this.name = navParams.get('name');
    this.gameCode = '';
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad JoinGamePage');
  }

  joinGame() {
    if (this.gameCode === '') {
      let toast = this.toastCtrl.create({
        message: 'Please enter a valid invite code',
        duration: 3000
      });
      toast.present();
      return ;
    }
    this.dataProvider.joinGame(this.name, this.gameCode);
  }
}



// WEBPACK FOOTER //
// ./src/pages/join-game/join-game.ts